<template>
  <b-container class="p-3" fluid>
    <b-ro>
      <b-col>
        <div v-if="!$apollo.loading">
          <b-card class="mb-4">
            <div class="ml-auto">
              <div v-if="!editMode">
                <b-button variant="primary" @click="editMode = true">
                  <font-awesome-icon icon="edit" />แก้ไขข้อมูลงบประมาณ
                </b-button>
              </div>
              <div v-else>
                <b-button variant="success" class="mr-2" @click="save">
                  <font-awesome-icon icon="save" />บันทึกข้อมูล
                </b-button>
                <b-button variant="secondary" @click="cancel">
                  <font-awesome-icon icon="save" />ยกเลิก
                </b-button>
              </div>
            </div>
          </b-card>

          <b-card class="mb-3">
            <h6 slot="header" class="mb-0">
              <font-awesome-icon icon="info" />ข้อมูลปีการศึกษา
            </h6>
            <dl class="row mb-0">
              <dt class="col-md-2 nowrap">ปีการศึกษา</dt>
              <dd class="col-md-9">{{ acYear.year }}</dd>
              <dt class="col-md-2 nowrap">ช่วงเวลา</dt>
              <dd class="col-md-9">{{ formatDate(acYear.startAt) }} ถึง {{ formatDate(acYear.endAt) }}</dd>
            </dl>
          </b-card>

          <b-card class="mb-3" no-body>
            <h6 slot="header" class="mb-0">
              <font-awesome-icon icon="info" />งบประมาณตามองค์กร
            </h6>
            <table v-if="!editMode" class="table table-bordered table-hover mb-0 border-0">
              <thead>
                <tr>
                  <th>องค์กร</th>
                  <th>งบประมาณที่ได้รับ (บาท)</th>
                  <!-- <th class="text-right">ใช้จริง</th>
                  <th class="text-right">คงเหลือ</th>-->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(group, index) in groups.data" :key="index">
                  <td class="align-middle">
                    <strong><span class="text-nowrap">{{ group.name }}</span></strong>
                  </td>
                  <td class="align-middle">{{ getReceivedAmount(group.id) | numeral('0,0.00') }}</td>
                  <!--
                  <td class="align-middle text-right">{{ acYear.funding[groupId].used | numeral('0,0.00') }}</td>
                  <td class="align-middle text-right">{{ acYear.funding[groupId].usableAmount | numeral('0,0.00') }}</td>
                  -->
                </tr>
              </tbody>
            </table>

            <table v-else class="table mb-0">
              <tbody>
                <tr v-for="(group, index) in groups.data" :key="index">
                  <td class="align-middle">
                    <strong><span class="text-nowrap">{{ group.name }}</span></strong>
                  </td>
                  <td class="align-middle">
                    <b-input-group append="บาท" style="width: 250px;">
                      <b-form-input v-model.number="acYear.groupFundings[getIndexInGroupFundings(group.id)].receivedAmount" type="number" step="0.01" min="0" />
                    </b-input-group>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-card>

          <b-card class="mb-4">
            <div class="ml-auto">
              <div v-if="!editMode">
                <b-button variant="primary" @click="editMode = true">
                  <font-awesome-icon icon="edit" />แก้ไขข้อมูลงบประมาณ
                </b-button>
              </div>
              <div v-else>
                <b-button variant="success" class="mr-2" @click="save">
                  <font-awesome-icon icon="save" />บันทึกข้อมูล
                </b-button>
                <b-button variant="secondary" @click="cancel">
                  <font-awesome-icon icon="save" />ยกเลิก
                </b-button>
              </div>
            </div>
          </b-card>
        </div>
      </b-col>
    </b-ro>
  </b-container>
</template>

<script>
import gql from 'graphql-tag'
import moment from 'moment'
import _ from 'lodash'

export default {
  apollo: {
    acYear: {
      query: gql`query GetAcYear($id: ID!) { acYear(id: $id) { id, year, groupFundings { groupId, receivedAmount }, startAt, endAt } }`,
      fetchPolicy: 'no-cache',
      variables () {
        return {
          id: this.$route.params.id
        }
      },
      result ({ data }) {
        this.groupFundings = _.each(data.acYear.groupFundings, function (groupFunding) {
          return delete groupFunding.__typename
        })
      }
    },
    groups: {
      query: gql`{ groups(enabledOnly: true, page:1, count:1000) { data { id, name, type, department } } }`
    }
  },
  data () {
    return {
      editMode: false,
      acYear: {
        id: null,
        year: '',
        groupFundings: [],
        startAt: '0000-00-00',
        endAt: '0000-00-00'
      },
      groups: {
        data: []
      },
      groupFundings: []
    }
  },
  methods: {
    refetch () {
      this.$apollo.queries.acYear.refetch()
    },
    formatDate (date) {
      return moment(date).format('DD-MM-YYYY')
    },
    getGroupName (id) {
      const group = this.groups.data.find(group => group.id === id)
      return group ? group.name : ''
    },
    getDepartmentName (id) {
      const group = this.groups.data.find(group => group.id === id)
      return group ? group.department : ''
    },
    getReceivedAmount (id) {
      const group = this.acYear.groupFundings.find(groupFunding => groupFunding.groupId === id)
      return group ? group.receivedAmount : 0
    },
    getIndexInGroupFundings (id) {
      const index = this.acYear.groupFundings.findIndex(groupFunding => groupFunding.groupId === id)
      return index !== -1 ? index : null
    },
    async save () {
      try {
        let response = await this.$apollo.mutate({
          mutation: gql`mutation ($input: GroupFundingUpdateAllByYearIdInput) {
            groupFundingUpdateAllGroupFundingsByAcYear(input: $input) {
              id,
              year,
              groupFundings {
                groupId,
                receivedAmount
              },
              startAt,
              endAt
            }
          }`,
          variables: {
            input: {
              yearId: this.acYear.id,
              data: this.groupFundings
            }
          }
        })

        this.acYear.groupFundings = response.data.groupFundingUpdateAllGroupFundingsByAcYear.groupFundings

        this.$bvToast.toast('บันทึกข้อมูลงบประมาณสำเร็จ', {
          title: 'สำเร็จ',
          variant: 'success',
          solid: true
        })

        this.editMode = false
      } catch (_) {
        this.$bvToast.toast('เกิดข้อผิดพลาดในการบันทึกข้อมูล ตรวจสอบการกรอกข้อมูลอีกครั้ง', {
          title: 'แจ้งเตือน',
          variant: 'danger',
          solid: true
        })
      }
    },
    cancel () {
      this.refetch()
      this.editMode = false
    }
  }
}
</script>

<style scoped lang="scss">
  td {

    &:first-child {
      background-color: #f2f2f2;
      width: 330px;
      p {
        margin-bottom: 0;
        font-size: $font-size-sm * 0.9;
        color: $gray-600;
      }
    }
  }
</style>
